// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.AccountInfo.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import AccountConstants from 'logic/data/Izenda.AccountConstants';
import actions from 'modules/Account/Izenda.AccountInfoActions';
import Validator from 'share/components/hoc/Izenda.Validator';
const ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
const CONSTRAINTS = AccountConstants.CONSTRAINTS;
import Loading from 'share/components/controls/Izenda.Loading';
// $FlowFixMe
import { isNil } from 'lodash/fp';

const Header = ({ localization, message }: { localization: any, message: string }) => (
  <div>
    <div>{localization.getText('ACOUNT_MESSAGE_PROVIDE_INFO_TO_CREATE_RESET_PASSWORD')}</div>
    {!isNil(message) ? <div className='izenda-Account-errorMessage'>{message}</div> : null}
  </div>
);

const Footer = ({ localization, onClickNext }: { localization: any, onClickNext: any }) => (
  <div className='u_textRight'>
    <button className='btn btn-primary izenda-Account-btn' onClick={onClickNext}>
      {localization.getText('ACOUNT_LABEL_NEXT')}
    </button>
  </div>
);

@connect(actions)
export default class AccountInfo extends Component {
  constructor(props: any) {
    super(props);
    props.checkShowOrganization(props.store);
  }

  /**
   * Render organization.
   */
  renderOrganization = () => {
    const { store, localization, onChangeTenantName } = this.props;
    const model = store.model;

    return model.hasOrg ? (
      <GridLayout.Row>
        <GridLayout.Col cols='3' className='u_textLeft'>
          <label>{localization.getText('ACOUNT_LABEL_ORGANIZATION')}</label>
        </GridLayout.Col>
        <GridLayout.Col cols='9'>
          <ValidateInput
            type='text'
            className='form-control'
            value={model.tenantName}
            onChange={onChangeTenantName}
            field='tenantName'
            validations={CONSTRAINTS.tenantName}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    ) : null;
  };

  /**
   * Render body.
   */
  renderBody = () => {
    const {
      store: { model },
      localization,
      onChangeUserName,
      onChangeFirstName,
      onChangeLastName,
      onChangeEmailAddress
    } = this.props;

    return (
      <GridLayout>
        {this.renderOrganization()}
        <GridLayout.Row>
          <GridLayout.Col cols='3' className='u_textLeft'>
            <label className='validation required'>{localization.getText('ACOUNT_LABEL_USER_ID')}</label>
          </GridLayout.Col>
          <GridLayout.Col cols='9'>
            <ValidateInput
              type='text'
              className='form-control'
              value={model.userName}
              onChange={onChangeUserName}
              field='userName'
              validations={CONSTRAINTS.userName}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='3' className='u_textLeft'>
            <label className='validation required'>{localization.getText('ACOUNT_LABEL_FIRST_NAME')}</label>
          </GridLayout.Col>
          <GridLayout.Col cols='9'>
            <ValidateInput
              type='text'
              className='form-control'
              value={model.firstName}
              onChange={onChangeFirstName}
              field='firstName'
              validations={CONSTRAINTS.firstName}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='3' className='u_textLeft'>
            <label className='validation required'>{localization.getText('ACOUNT_LABEL_LAST_NAME')}</label>
          </GridLayout.Col>
          <GridLayout.Col cols='9'>
            <ValidateInput
              type='text'
              className='form-control'
              value={model.lastName}
              onChange={onChangeLastName}
              field='lastName'
              validations={CONSTRAINTS.lastName}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='3' className='u_textLeft'>
            <label>{localization.getText('ACOUNT_LABEL_EMAIL')}</label>
          </GridLayout.Col>
          <GridLayout.Col cols='9'>
            <ValidateInput
              type='text'
              className='form-control'
              value={model.emailAddress}
              onChange={onChangeEmailAddress}
              field='emailAddress'
              validations={CONSTRAINTS.emailAddress}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  };

  render() {
    const {
      store: { model },
      localization,
      onClickNext
    } = this.props;
    if (!model.isCurrentStep(AccountConstants.STEP_KEYS.AccountInfo)) return null;

    const header = {
      component: Header,
      message: model.message,
      localization: localization
    };

    const footer = {
      component: Footer,
      onClickNext: onClickNext,
      localization: localization
    };

    if (!model.enableForEnter) {
      return <Loading show />;
    }

    return (
      <Panel className='izenda-Account-Container' header={header} footer={footer}>
        {this.renderBody()}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.AccountInfo.js